<template>
  <div class="pageNotFound">
    <div class="pageContent">
      <heading type="h1">404 - page not found</heading>
    </div>
  </div>
</template>

<script>
import Heading from '@/components/Heading/heading'

export default {
  name: 'PageNotFound',
  components: {
    Heading
  }
}
</script>

<style lang="scss">
    .pageNotFound .pageContent{
      width:100%;
      text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/pages/404.vue